// talentPool/{id} — see src/unAuth/About.js career form submissions.

// Fields: email, message, interests, resumeUrl, submittedAt.

const INTEREST_AREAS = Object.freeze([
  'Product',
  'Engineering',
  'Data',
  'Marketing',
  'Brand',
  'Community',
  'Finance',
  'Strategy',
]);

module.exports = { INTEREST_AREAS };
